export default "__VITE_ASSET__COjML01G__"